import React from 'react';

const InSampleBulletinAlert = () => {
  return (
    <div className="header-feedback alert alert-warning text-center">
      As licitações estão de acordo com o segmento da sua empresa? Podemos revisar o seu filtro.
      <button
        className="btn btn-info mx-2"
        onClick={() => {
          window.location.href = `/boletim_web/public/boletins?filter_review=true`;
        }}
        type="button"
      >
        Solicitar revisão
      </button>
    </div>
  );
};

export default InSampleBulletinAlert;
